import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { IoChevronBackOutline } from "react-icons/io5";

import Api from "../../app/api";
import { loginAuth } from "../../app/auth";

export default function LoginPage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const handleLogin = (e) => {
        e.preventDefault();
        setLoading(true);

        if (email === "") {
            alert("กรุณากรอกอีเมล");
            setLoading(false);
            return;
        }

        if (password.toString().length < 8) {
            alert("รหัสผ่านต้องมีตัวอักษรอย่างน้อย 8 ตัว");
            setLoading(false);
            return;
        }

        const formData = new FormData();
        formData.append("email", email);
        formData.append("password", password);

        //Send
        Api.post("/auth/login", formData)
            .then((response) => {
                const data = response.data;

                if (data.message === "OK") {
                    dispatch(loginAuth(data.obj));
                    localStorage.setItem("rdnatoken", data.obj.access_token);
                    navigate("/");
                } else if (data.message === "NOT_FOUND_EMAIL_OR_PASSWORD") {
                    alert("อีเมลหรือรหัสผ่านไม่ถูกต้อง");
                } else {
                    alert("เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง");
                }

                setLoading(false);
            })
            .catch((error) => {
                const data = error?.response?.data;

                if (data?.message === "invalid_email_or_password") {
                    alert("อีเมลหรือรหัสผ่านไม่ถูกต้อง");
                }

                setLoading(false);
            });
    };

    return (
        <div className="d-flex mw-100 py-5 h-100 flex-fill align-items-center justify-content-center" style={{ backgroundColor: "var(--main-background-light)" }}>
            <div className="container-sm" style={{ width: 888 }}>
                <div className="row shadow" style={{ border: "1px solid #f5f5f5" }}>
                    <div className="col-12 col-md-6 d-none d-md-block" style={{ backgroundColor: "var(--main-background-color)" }}>
                        <div className="container-text-to-image">
                            <img
                                src={`${process.env.PUBLIC_URL}/assets/undraws/undraw_login_re_4vu2.svg`}
                                alt="undraw_login_re_4vu2"
                                style={{ width: "100%", minHeight: 600 }}
                            />

                            <div className="text-to-image-top-left">
                                <div style={{ marginLeft: -28, marginTop: 50 }}>
                                    <span className="style-back-page" onClick={() => navigate("/")}>
                                        <IoChevronBackOutline />
                                        <span className="mx-2">กลับ</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6" style={{ backgroundColor: "#ffffff" }}>
                        <div className="p-5">
                            <div className="h3">เข้าสู่ระบบ</div>
                            <div>R-DNAM ฐานข้อมูลเครื่องหมายดีเอ็นเอข้าว</div>

                            <form onSubmit={handleLogin} className="mt-5">
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" className="form-label" style={{ fontSize: 12 }}>
                                        Email address
                                    </label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="exampleInputEmail1"
                                        aria-describedby="emailHelp"
                                        value={email}
                                        required
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputPassword1" className="form-label" style={{ fontSize: 12 }}>
                                        Password
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="exampleInputPassword1"
                                        value={password}
                                        required
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>

                                <div className="d-flex justify-content-between flex-wrap align-items-center">
                                    <div className="mt-4">
                                        <span className="a-style" onClick={() => navigate("/register")}>
                                            สมัครสมาชิก
                                        </span>
                                        <span className="a-style mx-4" onClick={() => navigate("/forgot")}>
                                            ลืมรหัสผ่าน
                                        </span>
                                    </div>
                                    <div className="mt-4">
                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                            เข้าสู่ระบบ
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
